// src/components/AppSelection.jsx
import React from 'react';
import '../../styles/page-styles/app_selection.css';
import curorx_re_site_logo from '../../assets/images/CuroRX_RE_SiteLogo.gif';
import app_curorx from '../../assets/images/app_curorx.png';
import app_sales from '../../assets/images/app_sales.png';
import app_ai from '../../assets/images/app_ai.png';

const AppSelection = ({ appAccess, onSelect }) => {
  return (
    <div
      className="container-fluid app_selection_container"
      id="index-top-logo-login-div"
      style={{ minHeight: '100vh' }}
    >
      <div className="row">
        <div className="col-md-6">
          <img
            src={curorx_re_site_logo}
            className="img-fluid"
            id="curo-re-logo"
            alt="Welcome to CuroRX"
          />
        </div>
      </div>
      <div className="row p-0 m-0 app_selection_apps">
        <div className="col offset-0">
          <h1 className="text-center">
            Welcome to <span>CuroRX</span>
            <span className="rx"> </span>
          </h1>
          <div className="container mt-5">
            <h2 className="mb-4 text-center text-white">
              Select an App to Continue
            </h2>
            <div className="list-group d-flex flex-row justify-content-evenly mt-5 ">
              {appAccess.map((app) => (
                <div
                  className="app_selection_box"
                  key={app}
                  onClick={() => onSelect(app)}
                  style={{
                    cursor: 'pointer',
                    textAlign: 'center',
                    margin: '0 10px',
                  }}
                >
                  <img
                    src={
                      app === 'sales'
                        ? app_sales
                        : app === 'curorx'
                          ? app_curorx
                          : app_ai
                    }
                    alt={app}
                    className="img-fluid app_selection_image"
                  />
                  <h4 key={app} className="text-center mt-3 text-white fs-3">
                    {app === 'sales'
                      ? 'CuroRx Sales'
                      : app === 'curorx'
                        ? 'CuroRx Pharmacy'
                        : 'CuroRx AI'}
                  </h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AppSelection;
